//export class RequisitionPartialBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RequisitionPartialGeneratedForm}];
//};

//export class RequisitionPartialListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RequisitionPartialListPageComponent, isMenuHidden: true }];
//};

import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/RequisitionPartialDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class RequisitionPartialEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartial"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartial/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartial/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartial/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartial/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartial/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartial/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class RequisitionPartialFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public status: IFieldOptions = { field: "status" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedById: IFieldOptions = { field: "changedById" };
	public identifier: IFieldOptions = { field: "identifier" };
	public latestRequisitionPartialWorkflowId: IFieldOptions = { field: "latestRequisitionPartialWorkflowId" };
	public exportedToSispro: IFieldOptions = { field: "exportedToSispro" };
  public sisproIdentifier: IFieldOptions = { field: "sisproIdentifier" };
  public emailSent: IColumnOptions = { field: "emailSent" };
  public sisproIdentifierPrefix: IFieldOptions = { field: "sisproIdentifierPrefix" };


	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.identifier);
		this.push(this.latestRequisitionPartialWorkflowId);
		this.push(this.exportedToSispro);
      this.push(this.sisproIdentifier);
      this.push(this.emailSent);
this.push(this.sisproIdentifierPrefix)
	}
}

export class RequisitionPartialForm implements IFormOptions {
	protected requisitionPartialFormName: string = "requisitionPartialForm";
	protected requisitionPartialFormModel: models.RequisitionPartialDTO = new models.RequisitionPartialDTO();
	protected requisitionPartialFormEndPoints: RequisitionPartialEndPoints = new RequisitionPartialEndPoints();
	protected requisitionPartialFormFields: RequisitionPartialFormFields = new RequisitionPartialFormFields();
	public get name(): string { return this.requisitionPartialFormName };
	public get model(): models.RequisitionPartialDTO { return this.requisitionPartialFormModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionPartialFormEndPoints };
       public set endPoints(requisitionPartialEndPoints: IEntityEndPoints) {
		this.requisitionPartialFormEndPoints = requisitionPartialEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): RequisitionPartialFormFields { return this.requisitionPartialFormFields };
}

export class RequisitionPartialListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public status: IColumnOptions = { field: "status" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedById: IColumnOptions = { field: "changedById" };
	public identifier: IColumnOptions = { field: "identifier" };
	public latestRequisitionPartialWorkflowId: IColumnOptions = { field: "latestRequisitionPartialWorkflowId" };
	public exportedToSispro: IColumnOptions = { field: "exportedToSispro" };
  public sisproIdentifier: IColumnOptions = { field: "sisproIdentifier" };
  public emailSent: IColumnOptions = { field: "emailSent" };
  public sisproIdentifierPrefix: IColumnOptions = { field: "sisproIdentifierPrefix" };
  
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.identifier);
		this.push(this.latestRequisitionPartialWorkflowId);
		this.push(this.exportedToSispro);
      this.push(this.sisproIdentifier);
      this.push(this.emailSent);
this.push(this.sisproIdentifierPrefix)
	}
}

export class RequisitionPartialList implements IGridOptions {
	protected requisitionPartialListName: string = "requisitionPartialList";
	protected requisitionPartialListModel: models.RequisitionPartialDTO = new models.RequisitionPartialDTO();
	protected requisitionPartialListEndPoints: RequisitionPartialEndPoints = new RequisitionPartialEndPoints();
	protected requisitionPartialListColumns: RequisitionPartialListColumns = new RequisitionPartialListColumns();
	public requisitionPartialForm: RequisitionPartialForm = new RequisitionPartialForm();
	public get name(): string { return this.requisitionPartialListName };
	public get model(): models.RequisitionPartialDTO { return this.requisitionPartialListModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionPartialListEndPoints };
	public set endPoints(requisitionPartialEndPoints: IEntityEndPoints) {
		this.requisitionPartialListEndPoints = requisitionPartialEndPoints;
		this.requisitionPartialForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): RequisitionPartialListColumns { return this.requisitionPartialListColumns };
}

export class RequisitionPartialEntity implements IEntityOptions {
	protected requisitionPartialEntityName: string = "requisitionPartialEntity";
	protected requisitionPartialEntityModel: models.RequisitionPartialDTO = new models.RequisitionPartialDTO();
	protected requisitionPartialEntityEndPoints: RequisitionPartialEndPoints = new RequisitionPartialEndPoints();
	protected requisitionPartialEntityList: RequisitionPartialList = new RequisitionPartialList();
	public get name(): string { return this.requisitionPartialEntityName };
	public get model(): models.RequisitionPartialDTO { return this.requisitionPartialEntityModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionPartialEntityEndPoints };
	public set endPoints(requisitionPartialEndPoints: IEntityEndPoints) {
		this.requisitionPartialEntityEndPoints = requisitionPartialEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): RequisitionPartialList { return this.requisitionPartialEntityList };
	public get form(): RequisitionPartialForm { return this.grid.requisitionPartialForm };
	constructor(name?: string) {
		if (name) this.requisitionPartialEntityName = name;
		this.endPoints = this.requisitionPartialEntityEndPoints;
	}
};
//export class RequisitionPartialGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: RequisitionPartialForm = new RequisitionPartialForm();
//};

//export class RequisitionPartialListPageComponent extends ListPageComponent {
  //protected listPageComponentList: RequisitionPartialList = new  RequisitionPartialList();
  //protected showFilterColOnTable: boolean = true;
//};

